export const MATCH_STATUS = {
  UPCOMING: 'UPCOMING',
  FINISHED: 'FINISHED',
  ONGOING: 'ONGOING',
  INTERRUPTED: 'INTERRUPTED',
};

export const MATCH_EXTENDED_STATUS = {
  POSTPONED: 'POSTPONED',
  UPCOMING: 'UPCOMING',
  UPCOMING_STARTING_SOON: 'UPCOMING_STARTING_SOON',
  UPCOMING_STARTING: 'UPCOMING_STARTING',
  ONGOING: 'ONGOING',
  INTERRUPTED: 'INTERRUPTED',
  FINISHED_RECENTLY: 'FINISHED_RECENTLY',
  FINISHED: 'FINISHED',
  CANCELED: 'CANCELED',
};

export const EVENT_TYPE = {
  OFFSIDE: 'OFFSIDE',
  SHOT: 'SHOT',
  SHOT_ON_TARGET: 'SHOT_ON_TARGET',
  FREE_KICK: 'FREE_KICK',
  CORNER: 'CORNER',
  SUBSTITUTION: 'SUBSTITUTION',
  WARNING: 'WARNING',
  SECOND_WARNING: 'SECOND_WARNING',
  GOAL: 'GOAL',
  PERIOD_RESULT: 'PERIOD_RESULT',
  PENALTY: 'PENALTY',
  PENALTY_KICK: 'PENALTY_KICK',
  PENALTY_MISSED: 'PENALTY_MISSED',
  CHANCE: 'CHANCE',
  START: 'START',
  MISC: 'MISC',
};

export const PERIODS = {
  PERIOD_FIRST_HALF: 'PERIOD_FIRST_HALF',
  PERIOD_SECOND_HALF: 'PERIOD_SECOND_HALF',
  PERIOD_FIRST_OVERTIME: 'PERIOD_FIRST_OVERTIME',
  PERIOD_SECOND_OVERTIME: 'PERIOD_SECOND_OVERTIME',
  PERIOD_PENALTIES: 'PERIOD_PENALTIES',
};

export const PERIOD_DATA = {
  [PERIODS.PERIOD_FIRST_HALF]: {
    START_MINUTE: 0,
    LENGTH: 45,
    INCLUSIVE_LENGTH: 45,
    EXPECTED_GAME_LENGTH: 90,
  },
  [PERIODS.PERIOD_SECOND_HALF]: {
    START_MINUTE: 45,
    LENGTH: 45,
    INCLUSIVE_LENGTH: 90,
    EXPECTED_GAME_LENGTH: 90,
  },
  [PERIODS.PERIOD_FIRST_OVERTIME]: {
    START_MINUTE: 90,
    LENGTH: 15,
    INCLUSIVE_LENGTH: 105,
    EXPECTED_GAME_LENGTH: 120,
  },
  [PERIODS.PERIOD_SECOND_OVERTIME]: {
    START_MINUTE: 105,
    LENGTH: 15,
    INCLUSIVE_LENGTH: 120,
    EXPECTED_GAME_LENGTH: 120,
  },
  [PERIODS.PERIOD_PENALTIES]: {
    START_MINUTE: 120,
    LENGTH: 0,
    INCLUSIVE_LENGTH: 120,
    EXPECTED_GAME_LENGTH: 120,
  },
};
